module.exports = __webpack_public_path__ + "static/media/Adherence_Documentation.625bd57e.pdf";